import Vue from 'vue'
import VueRouter from 'vue-router'

// import {
//   setDocumentDirectionPerLocale,
//   setDocumentLang,
//   setDocumentTitle
// } from "@/util/i18n/document"

Vue.use(VueRouter);
import i18n, {loadLocaleMessages} from './i18n'
import {
  setDocumentDirectionPerLocale,
  setDocumentLang,
  setDocumentTitle
} from "@/util/i18n/document"
const {
  locale
} = i18n

const routes = [
  {
    path: '/:locale/reg/:ide/:pli',
    name: 'registro',
    component: () => import( /* webpackChunkName: "registro" */ './views/MainRegForm.vue'),
  },
  {
    path: '/:locale/blank/:ide/:pli',
    name: 'blank',
    component: () => import( /* webpackChunkName: "blank" */ './components/BlankPage.vue'),
  },
  {
    path: '/:locale/thanks/:ide/:pli',
    name: 'thanks',
    component: () => import( /* webpackChunkName: "thanks" */ './components/ThanksPage.vue'),
  },
  {
    path: '/:locale/order/:ide/:pli',
    name: 'order',
    component: () => import( /* webpackChunkName: "confirm" */ './components/ConfirmOrder.vue'),
  }, 
//   {
//     path: '/:locale/profile/:ide',
//     name: 'profile-edit',
//     component: () => import( /* webpackChunkName: "profile" */ '@/views/Perfil.vue'),
//     meta: {
//       breadcrumb: [{
//           title: 'Home',
//           url: '/'
//         },
//         {
//           title: 'Perfil'
//         },
//         {
//           title: 'Modificar',
//           active: true
//         },
//       ],
//       pageTitle: 'Modificar perfil',
//       rule: 'editor'
//     },
//   },
  // {
  //   path: '/:locale/login/:ide/:pli',
  //   name: 'login',
  //   component: () => import( /* webpackChunkName: "tutorial" */ './components/LoginForm.vue'),
  // },
  
  {
    path: "/",
    redirect: locale + '/'
  },
//   {
//     path: '*',
//     component: NotAuthorized,
//     // component: () => import(/* webpackChunkName: "noauth" */ '@/views/NotAuthorized.vue'),
//   }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL, // eslint-disable-line
  routes
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

router.beforeEach((to, from, next) => {
  if (to.params.locale === from.params.locale) {
    next()
    return
  }

  const {
    locale
  } = to.params

  loadLocaleMessages(locale).then(() => {
    setDocumentLang(locale);
    setDocumentDirectionPerLocale(locale);
    setDocumentTitle(i18n.t("app.title"));
  })

  next()
})

export default router